if (!customElements.get("bz-media-marquee")) {
  customElements.define(
    "bz-media-marquee",
    class BzMediaMarquee extends HTMLElement {
      connectedCallback() {
        if (this.built) return;
        this.built = true;
        this.build();
      }

      cloneClean(node) {
        const copy = node.cloneNode(true);
        [copy, ...copy.querySelectorAll("*")].forEach((el) => {
          el.removeAttribute("id");
          Array.from(el.attributes).forEach((attr) => {
            if (attr.name.indexOf("data-shopify") === 0) el.removeAttribute(attr.name);
          });
        });
        copy.setAttribute("aria-hidden", "true");
        // Visual duplicate only: keep its links / buttons out of the Tab order
        [copy, ...copy.querySelectorAll("a[href], button, input, select, textarea, [tabindex]")]
          .filter((el) => el.matches("a[href], button, input, select, textarea, [tabindex]"))
          .forEach((el) => el.setAttribute("tabindex", "-1"));
        return copy;
      }

      build() {
        const track = this.querySelector("[data-mq-track]");
        const list = this.querySelector("[data-mq-list]");
        if (!track || !list) return;
        const items = Array.from(list.children).filter((el) => el.classList.contains("bz-mq__item"));
        if (!items.length) return;

        const repeat = items.length === 1 ? 3 : items.length === 2 ? 2 : 1;
        for (let r = 1; r < repeat; r += 1) {
          items.forEach((item) => list.appendChild(this.cloneClean(item)));
        }

        track.appendChild(this.cloneClean(list));
      }
    }
  );
}
